import { render, staticRenderFns } from "./openorderDertail.vue?vue&type=template&id=37ee2798&scoped=true&"
import script from "./openorderDertail.vue?vue&type=script&lang=js&"
export * from "./openorderDertail.vue?vue&type=script&lang=js&"
import style0 from "./openorderDertail.vue?vue&type=style&index=0&id=37ee2798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee2798",
  null
  
)

export default component.exports